
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/numeri-precedenti",
      function () {
        return require("private-next-pages/numeri-precedenti/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/numeri-precedenti"])
      });
    }
  